module.exports = require('./helpers/bundle-url').getBundleURL('dL7uY') + "logo-dark.eefe0b7f.svg";